module.exports = __webpack_public_path__ + "static/media/8D.ded2fc96.svg";